/**
 * @param cookieString Any RFC-6265 compliant cookie string. See https://datatracker.ietf.org/doc/html/rfc6265#section-5.4.
 * @param cookieName The name of any cookie.
 * @returns The value of the cookie as a string.
 */
export function getCookie(cookieString: string, cookieName: string) {
  return cookieString
    ?.split(';')
    ?.map((s) => s.trim())
    ?.filter((s) => s.startsWith(`${cookieName}=`))?.[0]
    ?.split('=')?.[1];
}
